
import { httpservice } from '../services';
import { constants } from '../constant/constant';
import {SOFTWARE, JOURNAL_ENTRIES} from '../constant/actionTypes';

export default object => dispatch => {
  let query;
  if (object && object.id) {
    query = `${constants.API.JOURNAL_ENTRIES}/${object.id}`;
  } else {
    const page = (object && object.page) ? object.page : 1;
    const limit = (object && object.limit) ? object.limit : 10;
    query = `${constants.API.JOURNAL_ENTRIES}?page=${page}&limit=${limit}`;
  }
  dispatch({
    payload: [],
    type: JOURNAL_ENTRIES.DATA.INITIATE
  });
  return httpservice()
    .get(query)
    .then(response => {
      const { rows = [], count = 0, totalPages = 1, page: currentPage = 1 } = response.data.response;
      // let softwareIdArray = [];
      const responseData = rows.map(data => {
      //   if (data.clientId) {
      //     if (softwareIdArray.includes(data.softwareId)) {
      //       return;
      //     } else {
      //       softwareIdArray.push(data.softwareId);
      //       return {
      //         id: data.softwareId,
      //         submoduleId: data.submoduleId,
      //         name: data.software.name,
      //         description: data.software.description,
      //         guid: data.software.guid,
      //         type: data.software.type,
      //         clientId: data.software.clientId,
      //         created_at: dateFormat(data.software.createdAt),
      //         createdBy: data.software.creator
      //           ? data.software.creator['firstName'] + ' ' + data.software.creator['lastName']
      //           : 'admin'
      //       };
      //     }
      //   } else {
      //     data.isPublicKey = data.isPublicKey ? 'Available' : 'Not Available';
          data.created_at = data.createdAt;
          data.created_by = data.creator ? data.creator.firstName + ' ' + data.creator.lastName : 'admin';
      //     data.subModuleId = null;
          return data;
        // }
      });

      const dataArray = responseData.filter(element => typeof element !== 'undefined');
      const respObject = { data: dataArray, count: count, totalPages: totalPages, page: currentPage };
      dispatch({
        payload: respObject,
        type: JOURNAL_ENTRIES.DATA.SUCCESS
      });
      return respObject;
    })
    .catch(function(error) {
      dispatch({
        payload: error,
        type: JOURNAL_ENTRIES.DATA.ERROR
      });
    });
};
